import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AsyncSelect from "react-select3/async";
import * as codeActions from "../../actions/codeActions";

const InvoiceFrequencySelect = ({
  isLoading,
  isDisabled,
  isMulti,
  values,
  name,
  label,
  placeholder,
  actions,
  codes,
  setValues = (x) => x,
  getValues = (x) => x,
  onChange
}) => {
  if (!codes.length) {
    actions.loadCodes();
  }

  const options = codes
    .filter((code) => code.field === "frequency")
    .map((c) => ({
      label: c.label,
      value: c._id
    }));

  const handleChange = (value) => {
    onChange(setValues(value));
  };

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="invoice-frequency-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <AsyncSelect
        id="invoice-frequency-select"
        name={name}
        className="react-select-container"
        classNamePrefix="react-select-container"
        isClearable
        defaultOptions={options}
        cacheOptions
        placeholder={placeholder}
        isLoading={isLoading}
        isDisabled={isDisabled}
        isMulti={isMulti}
        value={getValues(values)}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length ? "No options" : "Start typing..."
        }
        onChange={handleChange}
      />
    </React.Fragment>
  );
};

InvoiceFrequencySelect.propTypes = {
  name: PropTypes.string,
  values: PropTypes.array,
  label: PropTypes.string,
  codes: PropTypes.array,
  actions: PropTypes.object,
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  setValues: PropTypes.func,
  getValues: PropTypes.func,
  onChange: PropTypes.func
};

InvoiceFrequencySelect.defaultProps = {
  name: "invoice_frequency",
  placeholder: "Invoice Frequency",
  isLoading: false,
  isMulti: true,
  values: [],
  codes: []
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(InvoiceFrequencySelect);
